/* eslint-disable react/no-unused-class-component-methods */
import { Component } from 'react';
import { isEmpty } from 'lodash';
import moment from 'moment';
import { formatDateOnly, utcMoment } from '../../utilities/dateUtils';

class Form extends Component {
  constructor(props) {
    super(props);
    this.today = utcMoment(new Date());
    this.format = 'YYYY-MM-DD';
  }

  toggleEndDate = () => {
    const { isNoEndDate } = this.state;
    this.setState(prevState => ({ ...prevState, isNoEndDate: !isNoEndDate }));
    this.setErrorByField('exceptionEndTime', '');
  };

  onChangeHandler = field => event => {
    this.setErrorByField(field, ''); // reset error
    this.setState({ [field]: event.target.value });
  };

  onDateChangeHandler = field => date => {
    const dateValue = !isEmpty(date)
      && moment(date).isValid()
      && moment(new Date(date._d)).format('YYYY-MM-DD');
    this.setState(prevState => ({
      ...prevState,
      [field]: dateValue,
      errors: {
        ...prevState.errors,
        [field]: '',
      },
    }));
  };

  onDateFocusHandler = field => event => {
    if (!event) return;
    const { value } = event.target;
    this.setState({ [field]: value });
  };

  setErrorByField = (field, value) => {
    this.setState(prevState => ({
      ...prevState,
      errors: {
        ...prevState.errors,
        [field]: value,
      },
    }));
  };

  static handleInput(maxLength) {
    return event => {
      const inputLength = event.target.value.length;
      if (inputLength > maxLength) {
        event.target.value = event.target.value.slice(0, maxLength);
      }
    };
  }

  isPastDate = (date, format) => {
    const selectedMoment = moment(date, format, true).startOf('day');
    const today = this.today.startOf('day');
    return selectedMoment.isBefore(today);
  };

  static isInvalidDate(date, format) {
    const selectedMoment = moment(date, format, true);
    return selectedMoment.isValid();
  }

  validateEndDateDate = date => {
    const { isNoEndDate } = this.state;
    if (!isNoEndDate) {
      if (isEmpty(date)) {
        return 'The Exception End Date field is required.';
      } if (!Form.isInvalidDate(date, this.format)) {
        return `Please input with a correct format value of ${this.format}`;
      } if (this.isPastDate(date, this.format)) {
        return 'Please enter a date greater than or equal to current date';
      }
    }
    return null;
  };

  static onFormatInput(e) {
    // Prevent characters that are not numbers ("e", ".", "+" & "-") ✨
    let checkIfNum;
    if (e.key !== undefined) {
      checkIfNum = e.key === 'e' || e.key === '.' || e.key === '+' || e.key === '-';
    } else if (e.keyCode !== undefined) {
      checkIfNum = e.keyCode === 69
        || e.keyCode === 190
        || e.keyCode === 187
        || e.keyCode === 189;
    }
    return checkIfNum && e.preventDefault();
  }

  // receive from backend with format YYYY-MM-DD HH:mm:ss
  // -> so we need convert to YYYY-MM-DD to pass validate
  static initExceptionEndTimeString(exceptionEndTime) {
    if (!isEmpty(exceptionEndTime)) {
      return formatDateOnly(exceptionEndTime);
    }
    return null;
  }

  static initIsNoEndDate(id, exceptionEndTime) {
    if (id > 0) {
      return !exceptionEndTime;
    }
    return false;
  }
}
export default Form;
